import React from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'react-no-ssr';
import Ad from '@ifeng/ui_pc_ad';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import LeftNewsBox from './leftNewsBox';
import CenterNewsBox from './centerNewsBox';
import RightNewsBox from './rightNewsBox';

class NewsBox5 extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { leftData, centerData, rightData, fictionAd },
        } = this.props;

        return (
            <div className={styles.news_box}>
                <LeftNewsBox content={leftData} />
                <div className={styles.box_r}>
                    <div className="clearfix">
                        <CenterNewsBox content={centerData} />
                        <RightNewsBox content={rightData} />
                    </div>
                    <NoSSR>
                        <Ad content={fictionAd} styleName={styles.d_box} />
                    </NoSSR>
                </div>
            </div>
        );
    }
}

export default errorBoundary(NewsBox5);
